import { useState } from "react";
import { InvoiceList } from "@/components/admin/InvoiceList";
import { InvoiceForm } from "@/components/admin/InvoiceForm";

const TABS = [
  { id: "all", label: "All Invoices" },
  { id: "new", label: "New Invoice" },
];

export const InvoiceManager = () => {
  const [tab, setTab] = useState("all");
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = () => {
    setRefreshKey((k) => k + 1);
    setTab("all");
  };

  return (
    <div data-testid="admin-invoice-manager">
      <div className="flex gap-2 mb-6">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            data-testid={`invoice-tab-${t.id}`}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              tab === t.id ? "bg-gold text-[#0A140F]" : "bg-deep-card text-[#A1B0A6] hover:text-gold"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "new" ? <InvoiceForm onCreated={handleCreated} /> : <InvoiceList refreshKey={refreshKey} />}
    </div>
  );
};
